<template>
  <div id="app">
    <Header @unlockAll="unlockAll" />
    <Content @escolhePersona="escolhePersona" 
             @preencheDadosIniciais="preencheDadosIniciais" 
             @pulaPreenchimentoInicial="pulaPreenchimentoInicial"
             @refreshAos="refreshAos"
             :persona="persona" 
             :locked1="locked1"
             :locked2="locked2"
             :basicForm="basicForm"
             />
    <Footer v-if="locked1==0 && locked2==0" />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Content from './components/Content.vue'
import Footer from './components/Footer.vue'
import AOS from 'aos'
export default {
  name: 'App',
  data() {
    return {
          persona: 0,
          locked1: 1,
          locked2: 1,
          basicForm: {}
    }
  },
  methods: {
    escolhePersona(value) {
        console.log("ESCOLHE PERSONA ", value);
        this.persona = value;
        this.locked1 = 0;
    },
    preencheDadosIniciais(obj) {
        this.locked2 = 0;
        if(obj != undefined || obj != null) {
            this.basicForm = obj;
            console.log("FORM = ", this.basicForm);
        }
    },
    pulaPreenchimentoInicial() {
        this.locked2 = 0;
    },
    unlockAll() {
      this.locked1 = 0;
      this.locked2 = 0;
    },
    refreshAos() {
      AOS.refresh();
    }
  },
  components: {
    Header,
    Content,
    Footer
  }
}
</script>

<style lang="scss">
#app {
  position: relative;
}
</style>
